import { administrationRequests } from "api/administrationApi";
import { createExporter } from "utils/createExporter";
import { AttestationStatusChoices } from "utils/choices";
import { ATTESTATIONS } from "utils/constants";
import { getDisplayName } from "utils/helpers";
import { accountRequests } from "api/accountApi";

export const AttestationsExporter = createExporter(
  `student_${ATTESTATIONS}.xlsx`,
  [
    { key: "student", label: "студент" },
    { key: "discipline", label: "дисциплина" },
    { key: "professor", label: "преподавател" },
    { key: "classType", label: "тип занятие" },
    { key: "status", label: "статус заверка" },
    { key: "youngChildrenMotherText", label: "родител" },
    { key: "note", label: "коментар" },
    { key: "classesAttended", label: "присъствия" },
    { key: "classesAbsent", label: "отсъствия" },
  ],
  record => ({
    ...record,
    student: getDisplayName(record.student),
    discipline: record.discipline?.name,
    professor: getDisplayName(record.professor),
    classType: record.classType?.name,
    status: AttestationStatusChoices[record.status],
  }),
  [
    {
      source: "studentId",
      target: accountRequests.getUsersSelect(),
      name: "student",
    },
    {
      source: "disciplineId",
      target: administrationRequests.getDisciplinesSelect(),
      name: "discipline",
    },
    {
      source: "professorEmployeeId",
      target: accountRequests.getUsersSelect(),
      name: "professor",
    },
    {
      source: "classTypeId",
      target: administrationRequests.getRoomClassTypesSelect(),
      name: "classType",
    },
  ],
);
